"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedItemJSONSchema = void 0;
const attribute_js_1 = require("./attribute.js");
const getFormattedItemJSONSchema = (schema) => {
    const displayedAttrEntries = Object.entries(schema.attributes).filter(([, attribute]) => !attribute.hidden);
    const requiredProperties = displayedAttrEntries
        .filter(([, { required }]) => required === 'atLeastOnce' || required === 'always')
        .map(([attributeName]) => attributeName);
    return {
        type: 'object',
        properties: Object.fromEntries(displayedAttrEntries.map(([attributeName, attribute]) => [
            attributeName,
            (0, attribute_js_1.getFormattedAttrJSONSchema)(attribute)
        ])),
        ...(requiredProperties.length > 0 ? { required: requiredProperties } : {})
    };
};
exports.getFormattedItemJSONSchema = getFormattedItemJSONSchema;
